var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbumIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.6858V9.34717H29.1733V21.7847C29.1733 26.8722 25.9709 30.0002 20.8472 30.0002H8.31006C3.23436 30.0002 0 26.8074 0 21.6858ZM10.3816 18.3836C11.8701 18.3836 13.0816 17.1722 13.0816 15.6836C13.0816 14.1951 11.8701 12.9826 10.3816 12.9826C8.89197 12.9826 7.68159 14.1951 7.68159 15.6836C7.68159 17.1722 8.89197 18.3836 10.3816 18.3836ZM22.4967 20.7684C22.3772 20.4696 22.1957 20.1893 21.9426 19.9438C21.2787 19.3016 20.6583 18.7019 19.9206 18.2586C18.7634 17.5545 17.8681 18.5433 17.6269 18.8594C17.4325 19.1148 17.2608 19.3921 17.0865 19.6738L17.0865 19.6738C17.0524 19.7289 17.0182 19.7842 16.9837 19.8395L16.9734 19.8561C16.4608 20.6824 15.8719 21.6316 14.8574 22.1863C13.3732 22.986 12.2465 22.2494 11.436 21.7126C11.1317 21.5127 10.8362 21.3226 10.5418 21.1965C9.81597 20.8912 9.16297 21.2389 8.1938 22.4384C7.68531 23.0653 7.18116 23.6868 6.6705 24.3061C6.36519 24.6777 6.43799 25.2481 6.84978 25.4959C7.50712 25.8914 8.30897 26.1022 9.21512 26.1022H18.3212C18.8351 26.1022 19.3502 26.0348 19.8413 25.8772C20.9473 25.5252 21.8252 24.7201 22.2837 23.6542C22.6705 22.7589 22.8585 21.6724 22.4967 20.7684Z",
    fill: "#2884FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.10364,
    y: 4.06836,
    width: 12.9659,
    height: 2.43111,
    rx: 1.21555,
    fill: "#2884FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.00561523 9.34679C0.0264304 8.39542 0.106489 6.50726 0.256998 5.89948C1.02556 2.48135 3.63546 0.309561 7.36618 0H21.8087C25.5074 0.325768 28.1493 2.51214 28.9179 5.89948C29.0668 6.49105 29.1469 8.3938 29.1677 9.34679H0.00561523Z",
    fill: "#2884FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumIconSelected);
export default __webpack_public_path__ + "static/media/album-icon-selected.060dddc0b64d91a37fd352ccf6d8482d.svg";
export { ForwardRef as ReactComponent };